/* CYPHERDONE — Neural Network Theme JS */

/* ── PARTNER CODES — single source of truth ── */
var PARTNER_CODES = {
  'SENTARA2026': { org: 'sentara', label: 'Sentara Health',        collection: 'sentara' },
  'SENTARA-HH':  { org: 'sentara', label: '4H Heart Hospital',     collection: 'sentara' },
  '4HDEPT2026':  { org: 'sentara', label: '4H Sentara Department', collection: '4h-department' },
  'CSICU2026':   { org: 'sentara', label: 'Sentara CSICU',         collection: 'sentara-csicu' },
  'TCCEMS2026':  { org: 'tcc',     label: 'TCC EMS Program',       collection: 'tcc-ems' },
  'TCCFALL26':   { org: 'tcc',     label: 'TCC EMS Program',       collection: 'tcc-ems' },
  'EMS111FA26':    { org: 'tcc',     label: 'TCC EMS 111',          collection: 'tccems-ems-111' },
  'EMS112FA26':    { org: 'tcc',     label: 'TCC EMS 112',          collection: 'tccems-ems-112' },
  'AEMTFA26':      { org: 'tcc',     label: 'TCC AEMT',             collection: 'tccems-aemt' },
  'PARAMEDICFA26': { org: 'tcc',     label: 'TCC Paramedic',        collection: 'tccems-paramedic' },
  'ONLYSTAFF26':     { org: 'tcc',     label: 'TCC EMS Staff',        collection: 'tccems-staff' },
  'VBPURCH2026':   { org: 'tcc',     label: 'EMS 112 VB Purchasing Department', collection: 'ems-112-vb-dual-enrollment' },
  'DEVB2627':      { org: 'tcc',     label: 'TCC EMS Dual Enrollment - Virginia Beach', collection: 'tccems-dual-enrollment-vb' },
  'DECC2627':      { org: 'tcc',     label: 'TCC EMS Dual Enrollment - Chesapeake',     collection: 'tccems-dual-enrollment-chesapeake' },
  'XYNTIX2026':  { org: 'xyntix',  label: 'Xyntix Apparel',        collection: 'xyntix-apparel' }
};

/* ── Toast ── */
function showToast(msg, duration) {
  duration = duration || 3000;
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, duration);
}

/* ── Cart Count ── */
function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var el = document.getElementById('cartCount');
      if (el) el.textContent = cart.item_count;
    });
}

/* ── Qty Controls (delegated) ── */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.qty-btn[data-dir]');
  if (!btn) return;
  var input = btn.parentElement.querySelector('.qty-input');
  if (!input) return;
  var val = parseInt(input.value) || 1;
  if (btn.dataset.dir === 'up') val = Math.min(val + 1, 99);
  if (btn.dataset.dir === 'dn') val = Math.max(val - 1, 1);
  input.value = val;
});

/* ── Partner Portal Code Gate ── */
function tryPortalUnlock() {
  var input = document.getElementById('portalCodeInput');
  var error = document.getElementById('portalCodeError');
  var gate  = document.getElementById('portalGate');
  var open  = document.getElementById('portalUnlocked');
  var label = document.getElementById('portalOrgLabel');
  if (!input) return;
  var code = input.value.trim().toUpperCase().replace(/[\s\-]/g, '');
  var match = null;
  Object.keys(PARTNER_CODES).forEach(function(k) {
    if (k.replace(/[\s\-]/g, '') === code) match = PARTNER_CODES[k];
  });
  if (match) {
    sessionStorage.setItem('partner-access', JSON.stringify({ ts: Date.now(), org: match.org, label: match.label, collection: match.collection }));
    if (match.org === 'sentara') sessionStorage.setItem('sentara-access', JSON.stringify({ ts: Date.now(), label: match.label, collection: match.collection }));
    if (match.org === 'tcc')     sessionStorage.setItem('tcc-access',     JSON.stringify({ ts: Date.now(), label: match.label }));
    if (match.org === 'xyntix')  sessionStorage.setItem('xyntix-access',  JSON.stringify({ ts: Date.now(), label: match.label, collection: match.collection }));
    if (error) error.style.display = 'none';
    if (label) label.textContent = match.label;
    setTimeout(function() {
      if (gate) gate.style.display = 'none';
      if (open) open.style.display = 'block';
    }, 300);
  } else {
    if (error) error.style.display = 'block';
  }
}

function lockPortal() {
  sessionStorage.removeItem('partner-access');
  sessionStorage.removeItem('sentara-access');
  sessionStorage.removeItem('tcc-access');
  sessionStorage.removeItem('xyntix-access');
  window.location.href = '/pages/department-access';
}

/* ── Restore partner portal session on portal page ── */
(function() {
  var stored = sessionStorage.getItem('partner-access');
  if (!stored) return;
  try {
    var d = JSON.parse(stored);
    var gate  = document.getElementById('portalGate');
    var open  = document.getElementById('portalUnlocked');
    var label = document.getElementById('portalOrgLabel');
    if (gate && open) {
      gate.style.display = 'none';
      open.style.display = 'block';
      if (label) label.textContent = d.label;
    }
  } catch(e) { sessionStorage.removeItem('partner-access'); }
})();

/* Portal input enter key */
(function() {
  var input = document.getElementById('portalCodeInput');
  if (!input) return;
  input.addEventListener('keydown', function(e) { if (e.key === 'Enter') tryPortalUnlock(); });
})();

/* ── Cart count on load ── */
updateCartCount();
